/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AccountsPayableAuditLogActivity,
  ApprovalStepActivity,
  ApprovalStepActivityV2,
  Base64Image,
  CommentActivity,
  CreateDimensionMappingRequest,
  ExportEventActivity,
  ExternalActionActivityV2,
  ExternalReceiptAccountDto,
  GetInvoiceSummaryHeaderRequest,
  GetInvoicesThumbnailsPayload,
  InvoiceFieldOptionCreateRequest,
  InvoiceFieldOptionDto,
  InvoiceFieldOptionUpdateRequest,
  InvoiceListRequest,
  InvoiceSummaryHeaderDto,
  ManuallyForwardActivity,
  PaymentActivity,
  StatusChangeActivity,
  StatusChangeOfPurchaseRequestActivity,
  SubInvoiceDto,
  SystemActionActivityV2,
  SystemPaymentActionActivityV2,
  UpdateSubInvoicesPayload,
  UserActionActivity,
  UserActionActivityV2,
  UserActionOfPurchaseRequestActivity,
  UserFieldChangeActivity,
  VerificationStepActivityV2,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiInvoicesController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-invoices-controller
   * @name GetSubInvoices
   * @request GET:/api/v1/invoices/{invoiceId}/sub-invoices
   */
  getSubInvoices = (invoiceId: string, params: RequestParams = {}) =>
    this.http.request<SubInvoiceDto[], any>({
      path: `/v1/invoices/${invoiceId}/sub-invoices`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSubInvoicesPath = '/v1/invoices/${invoiceId}/sub-invoices'
  static getSubInvoicesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-invoices-controller
   * @name UpdateSubInvoices
   * @request PUT:/api/v1/invoices/{invoiceId}/sub-invoices
   */
  updateSubInvoices = (
    invoiceId: string,
    data: UpdateSubInvoicesPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<SubInvoiceDto[], any>({
      path: `/v1/invoices/${invoiceId}/sub-invoices`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateSubInvoicesPath = '/v1/invoices/${invoiceId}/sub-invoices'
  static updateSubInvoicesMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-invoices-controller
   * @name DeleteSubInvoices
   * @request DELETE:/api/v1/invoices/{invoiceId}/sub-invoices
   */
  deleteSubInvoices = (invoiceId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/invoices/${invoiceId}/sub-invoices`,
      method: 'DELETE',
      ...params,
    })

  static deleteSubInvoicesPath = '/v1/invoices/${invoiceId}/sub-invoices'
  static deleteSubInvoicesMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-invoices-controller
   * @name UpdateInvoiceFieldOption
   * @request PUT:/api/v1/invoices/{invoiceId}/invoice-field-options
   */
  updateInvoiceFieldOption = (
    invoiceId: string,
    data: InvoiceFieldOptionUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<InvoiceFieldOptionDto, any>({
      path: `/v1/invoices/${invoiceId}/invoice-field-options`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateInvoiceFieldOptionPath = '/v1/invoices/${invoiceId}/invoice-field-options'
  static updateInvoiceFieldOptionMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-invoices-controller
   * @name CreateInvoiceFieldOption
   * @request POST:/api/v1/invoices/{invoiceId}/invoice-field-options
   */
  createInvoiceFieldOption = (
    invoiceId: string,
    data: InvoiceFieldOptionCreateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<InvoiceFieldOptionDto, any>({
      path: `/v1/invoices/${invoiceId}/invoice-field-options`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createInvoiceFieldOptionPath = '/v1/invoices/${invoiceId}/invoice-field-options'
  static createInvoiceFieldOptionMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invoices-controller
   * @name CreateOrUpdateDimensionMapping
   * @request POST:/api/v1/invoices/{invoiceId}/sub-invoices/{subInvoiceId}/dimension-mapping
   */
  createOrUpdateDimensionMapping = (
    invoiceId: string,
    subInvoiceId: string,
    data: CreateDimensionMappingRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/invoices/${invoiceId}/sub-invoices/${subInvoiceId}/dimension-mapping`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static createOrUpdateDimensionMappingPath =
    '/v1/invoices/${invoiceId}/sub-invoices/${subInvoiceId}/dimension-mapping'
  static createOrUpdateDimensionMappingMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invoices-controller
   * @name GetInvoicesThumbnails
   * @request POST:/api/v1/invoices/thumbnails
   */
  getInvoicesThumbnails = (data: GetInvoicesThumbnailsPayload, params: RequestParams = {}) =>
    this.http.request<Base64Image[], any>({
      path: `/v1/invoices/thumbnails`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getInvoicesThumbnailsPath = '/v1/invoices/thumbnails'
  static getInvoicesThumbnailsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invoices-controller
   * @name GetInvoicesSummary
   * @request POST:/api/v1/invoices/summary
   */
  getInvoicesSummary = (data: GetInvoiceSummaryHeaderRequest, params: RequestParams = {}) =>
    this.http.request<InvoiceSummaryHeaderDto, any>({
      path: `/v1/invoices/summary`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getInvoicesSummaryPath = '/v1/invoices/summary'
  static getInvoicesSummaryMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invoices-controller
   * @name StreamDownloadZipInvoices
   * @request POST:/api/v1/invoices/file/batch
   */
  streamDownloadZipInvoices = (data: InvoiceListRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/invoices/file/batch`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static streamDownloadZipInvoicesPath = '/v1/invoices/file/batch'
  static streamDownloadZipInvoicesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invoices-controller
   * @name StreamDownloadZipInvoicesAsMergedPdfs
   * @request POST:/api/v1/invoices/file/batch/merged-pdfs
   */
  streamDownloadZipInvoicesAsMergedPdfs = (data: InvoiceListRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/invoices/file/batch/merged-pdfs`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static streamDownloadZipInvoicesAsMergedPdfsPath = '/v1/invoices/file/batch/merged-pdfs'
  static streamDownloadZipInvoicesAsMergedPdfsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invoices-controller
   * @name DownloadInvoicesCustomCsv
   * @request POST:/api/v1/invoices/csv/templates/{templateId}
   */
  downloadInvoicesCustomCsv = (
    templateId: string,
    data: InvoiceListRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/invoices/csv/templates/${templateId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static downloadInvoicesCustomCsvPath = '/v1/invoices/csv/templates/${templateId}'
  static downloadInvoicesCustomCsvMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invoices-controller
   * @name GetInvoiceThumbnail
   * @request GET:/api/v1/invoices/{invoiceId}/thumbnail
   */
  getInvoiceThumbnail = (invoiceId: string, params: RequestParams = {}) =>
    this.http.request<Base64Image, any>({
      path: `/v1/invoices/${invoiceId}/thumbnail`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getInvoiceThumbnailPath = '/v1/invoices/${invoiceId}/thumbnail'
  static getInvoiceThumbnailMethod = 'GET'
  /**
   * No description
   *
   * @tags api-invoices-controller
   * @name DownloadInvoiceFile1
   * @request GET:/api/v1/invoices/{invoiceId}/file/download
   */
  downloadInvoiceFile = (invoiceId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/invoices/${invoiceId}/file/download`,
      method: 'GET',
      ...params,
    })

  static downloadInvoiceFilePath = '/v1/invoices/${invoiceId}/file/download'
  static downloadInvoiceFileMethod = 'GET'
  /**
   * No description
   *
   * @tags api-invoices-controller
   * @name FindActivityByInvoiceIdV2
   * @request GET:/api/v1/invoices/{invoiceId}/activity/v2
   * @deprecated
   */
  findActivityByInvoiceIdV2 = (invoiceId: string, params: RequestParams = {}) =>
    this.http.request<
      (
        | AccountsPayableAuditLogActivity
        | ApprovalStepActivity
        | ApprovalStepActivityV2
        | CommentActivity
        | ExportEventActivity
        | ExternalActionActivityV2
        | ManuallyForwardActivity
        | PaymentActivity
        | StatusChangeActivity
        | StatusChangeOfPurchaseRequestActivity
        | SystemActionActivityV2
        | SystemPaymentActionActivityV2
        | UserActionActivity
        | UserActionActivityV2
        | UserActionOfPurchaseRequestActivity
        | UserFieldChangeActivity
        | VerificationStepActivityV2
      )[],
      any
    >({
      path: `/v1/invoices/${invoiceId}/activity/v2`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findActivityByInvoiceIdV2Path = '/v1/invoices/${invoiceId}/activity/v2'
  static findActivityByInvoiceIdV2Method = 'GET'
  /**
   * No description
   *
   * @tags api-invoices-controller
   * @name GetInvoiceInboxAccount
   * @request GET:/api/v1/invoices/account
   */
  getInvoiceInboxAccount = (params: RequestParams = {}) =>
    this.http.request<ExternalReceiptAccountDto, any>({
      path: `/v1/invoices/account`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getInvoiceInboxAccountPath = '/v1/invoices/account'
  static getInvoiceInboxAccountMethod = 'GET'
  /**
   * No description
   *
   * @tags api-invoices-controller
   * @name DeleteDimensionMapping
   * @request DELETE:/api/v1/invoices/{invoiceId}/sub-invoices/{subInvoiceId}/dimension-mapping/{dimensionId}
   */
  deleteDimensionMapping = (
    invoiceId: string,
    subInvoiceId: string,
    dimensionId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/invoices/${invoiceId}/sub-invoices/${subInvoiceId}/dimension-mapping/${dimensionId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteDimensionMappingPath =
    '/v1/invoices/${invoiceId}/sub-invoices/${subInvoiceId}/dimension-mapping/${dimensionId}'
  static deleteDimensionMappingMethod = 'DELETE'
}
